var spacing;
(function (spacing) {
    spacing["XS3"] = "0.125rem";
    spacing["XS2"] = "0.25rem";
    spacing["XS"] = "0.5rem";
    spacing["S"] = "0.75rem";
    spacing["M"] = "1rem";
    spacing["L"] = "1.5rem";
    spacing["XL"] = "2rem";
    spacing["XL2"] = "2.5rem";
    spacing["XL3"] = "3rem";
    spacing["XL4"] = "4rem";
    spacing["XL5"] = "6rem";
    spacing["XL6"] = "8rem";
    spacing["XL7"] = "16rem";
})(spacing || (spacing = {}));

export { spacing };
